module.exports = __webpack_public_path__ + "img/spouse.c223811c.svg";